export const runFacebook = (trackParam, params) => {
  try {
    window.fbq.disablePushState = true;
    window.fbq('init', '1350651451690366');
    window.fbq('track', trackParam, params);
  } catch (e) {
    console.error(e);
  }
};

export const runYuhagent = (price, orderId) => {
  const namespaces = ['__yuhagent', '__yuhagent_dev'];

  for (let i = 0; i < namespaces.length; i++) {
    const namespace = namespaces[i];

    window[namespace] =
      window[namespace] ||
      function () {
        (window[namespace].q = window[namespace].q || []).push(arguments);
      };

    window[namespace]('order_placed', {
      value: price,
      id: orderId
    });
  }
};

// export const runGoogleAnalytics = () => {
//     try {
//         function gtag() {
//             dataLayer.push(arguments);
//         }
//         const page = getPage()

//         if (page === 'pesquisa') {
//             window.gtag("event", "conversion", {
//               send_to: "AW-797626440/2j-VCM31oZIBEMigq_wC"
//             });
//         }
//         else if (page === 'pos-compra') {
//             window.gtag("event", "conversion", {
//               send_to: "AW-797626440/oTXVCIr3oZIBEMigq_wC",
//             });
//         }
//     }
//     catch (e) {
//         console.error(e)
//     }
// }

export const runGoogleAdWordsConversion = (id, value) => {
  // try {
  //     window.gtag('event', 'conversion', {
  //         send_to: 'AW-797626440/oTXVCIr3oZIBEMigq_wC',
  //         value,
  //         currency: 'BRL',
  //         transaction_id: id,
  //     });
  // }
  // catch (e) {
  //     console.error(e)
  // }
};

export const runGoogleAdWordsConversionSearch = () => {
  // try {
  //     window.gtag('event', 'conversion', {
  //         send_to: 'AW-797626440/2j-VCM31oZIBEMigq_wC'
  //     });
  // }
  // catch (e) {
  //     console.error(e)
  // }
};

export const NewRunGoogleAdwordsConversion = (id) => {
  // try {
  //     window.gtag('event', 'conversion', {
  //         send_to: 'AW-797626440/g5CaCJ-otcQBEMigq_wC',
  //         transaction_id: id
  //     });
  // }
  // catch (e){
  //     console.log(e)
  // }
};



// WEBPACK FOOTER //
// ./src/SeoFunctions.js